import { z } from "zod";

const guidSchema = z.string().uuid();
const nullableTextSchema = z.string().nullable().optional();
const nullableDateSchema = z.string().datetime({ offset: true }).nullable().optional();

export const verificationRecordSchema = z.object({
  id: guidSchema,
  complaintId: guidSchema,
  verificationRuleId: guidSchema,
  verificationRuleCode: z.string().min(1),
  verificationRuleName: z.string().min(1),
  verifierUserId: guidSchema,
  verifierName: z.string().min(1),
  verificationStatusId: guidSchema,
  verificationStatusCode: z.string().min(1),
  verificationStatusName: z.string().min(1),
  remarks: nullableTextSchema,
  verifiedAt: nullableDateSchema,
  rejectedAt: nullableDateSchema,
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: nullableDateSchema,
  rowVersion: nullableTextSchema,
}).strict();

export type VerificationRecordDto = z.infer<typeof verificationRecordSchema>;
export type VerificationDto = VerificationRecordDto;
export type VerificationMutationResponse = VerificationRecordDto;

export type VerificationCreateRequest = Readonly<{
  complaintId: string;
  verificationRuleId: string;
  verifierUserId: string;
  pendingStatusId: string;
}>;

export type VerificationUpdateRequest = Readonly<{
  verificationRuleId?: string | undefined;
  verifierUserId?: string | undefined;
  remarks?: string | undefined;
  rowVersion?: string | undefined;
}>;

export type VerificationDecisionRequest = Readonly<{
  verificationStatusId: string;
  remarks?: string | undefined;
  rowVersion?: string | undefined;
}>;

export function parseVerificationRecord(input: unknown): VerificationRecordDto {
  return verificationRecordSchema.parse(input);
}

export function parseVerificationRecordList(input: unknown): readonly VerificationRecordDto[] {
  return z.array(verificationRecordSchema).parse(input);
}
